import { ButtonV2, Heading, Text, VerticalSpace } from '@arc-ui/components';

export const ErrorFallback = ({
  error,
  resetError,
}: {
  error: Error | null;
  resetError: () => void;
}) => (
  <div>
    <Heading level="2" size="m">
      Something went wrong:
    </Heading>
    <VerticalSpace size="16" />
    <Text elementType="p">{error?.message ?? ''}</Text>
    <VerticalSpace size="24" />
    <ButtonV2 label="Try again" onClick={resetError} />
  </div>
);
